import { Injectable } from '@angular/core';
import { LoadingController, Loading, LoadingOptions } from 'ionic-angular';

@Injectable()
export class LoaderProvider {

  constructor(public loadingCtrl: LoadingController) {}

  public createLoader(options?: LoadingOptions): Loading {
    return this.loadingCtrl.create(options);
  }

  public presentLoader(options?: LoadingOptions): Loading {
    let loader = this.loadingCtrl.create(options);
    loader.present();
    return loader;
  }
}
